import { Button } from "@components/ui/button"
import { Heading } from "@components/ui/typograhpy/Heading"
import { Text } from "@components/ui/typograhpy/Text"
import { BuiltInProviderType } from "next-auth/providers/index"
import { ClientSafeProvider, LiteralUnion, signIn } from "next-auth/react"
import Link from "next/link"
import { FC } from "react"
import { LoginFormForm as Form } from "./Form"

type LoginFormProps = {
  providers: Record<
    LiteralUnion<BuiltInProviderType, string>,
    ClientSafeProvider
  > | null
}

export const LoginForm: FC<LoginFormProps> = ({ providers }) => {
  const google = providers && providers.google
  const apple = providers && providers.apple
  return (
    <div className="flex w-full flex-wrap justify-center md:justify-start">
      <Heading variant="h2" className="mb-4">
        Log in
      </Heading>
      <div className="flex w-full flex-col items-center">
        <Text variant="small" className="mb-4 font-medium text-white">
          Welcome back! Log in to continue where you left off. New to Viesus?{" "}
          {
            <Link href="/signup/create-account" passHref className="underline">
              Create an account!
            </Link>
          }
        </Text>
        <Form />
        {(google || apple) && (
          <>
            {google && (
              <Button
                variant="secondary"
                data-testid="login-with-google"
                leftIcon="google"
                onClick={() => signIn(google.id as any)}
                className="mb-4"
                width="fill"
              >
                Continue with Google
              </Button>
            )}
            {apple && (
              <Button
                variant="secondary"
                leftIcon="apple"
                className="mb-4"
                onClick={() => signIn(apple.id as any)}
                width="fill"
              >
                Continue with Apple
              </Button>
            )}
          </>
        )}
      </div>
    </div>
  )
}
